module.exports = __webpack_public_path__ + "img/left_nav_back.be5cdea8.jpg";